// Shared font loader for the catalog template previews.
// We import Fontshare (Cabinet Grotesk, Satoshi) + Google fonts via <link>
// once at the top of each preview page so the templates render with
// their real typefaces, not a system fallback.
import { useEffect } from "react";

const FONT_HREFS = [
  // Google Fonts — covers Work Sans, IBM Plex Sans, Playfair Display, Outfit,
  // Chivo, Bodoni Moda, Roboto Mono, JetBrains Mono in one request.
  "https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=Outfit:wght@300;400;500;600;700&family=Chivo:wght@300;400;500;600;700;800&family=Bodoni+Moda:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=Roboto+Mono:wght@300;400;500;600&family=JetBrains+Mono:wght@300;400;500;600&display=swap",
  // Fontshare — Cabinet Grotesk + Satoshi
  "https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@400,500,700,800&f[]=satoshi@300,400,500,700&display=swap",
];

export function useCatalogFonts() {
  useEffect(() => {
    const added = [];
    FONT_HREFS.forEach((href) => {
      if (document.querySelector(`link[href="${href}"]`)) return;
      const l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      document.head.appendChild(l);
      added.push(l);
    });
    return () => { added.forEach((l) => l.remove()); };
  }, []);
}
